export default {
  topicManagerRange_Week_top_list: 'Weekly list',
  topicManagerRange_mouth_top_list: 'Monthly list',
  topicManagerRange_results_count: '{Count} entries found. Show {from} to {to} entries',
  topicManagerRange_ranking: 'Ranking',
  topicManagerRange_user: 'User',
  topicManagerRange_organization: 'Organization',
  topicManagerRange_likes_num: 'Likes',
  topicManagerRange_top_week: 'Circle owner ranking - weekly',
  topicManagerRange_top_mouth: 'Circle owner ranking - monthly'
}
